// src/projects.js

const API_KEY = process.env.REACT_APP_API_KEY;

export const projects = [
  {
    title: 'Augustine',
    description: 'HTML5 CSS3 Landing Page.',
    link: 'https://e3613262.digitalkreatif.pages.dev/',
    image: `https://api.screenshotmachine.com?key=${API_KEY}&url=https://e3613262.digitalkreatif.pages.dev/&dimension=1280x870`,
    code : '#0001'
  },
  {
    title: 'Carint',
    description: 'Transportation Service Landing Page.',
    link: 'https://d2d2c8ad.digitalkreatif.pages.dev/',
    image: `https://api.screenshotmachine.com?key=${API_KEY}&url=https://d2d2c8ad.digitalkreatif.pages.dev/&dimension=1280x870`,
    code : '#0002'
  },
  {
    title: 'Snap',
    description: 'Bootstrap 4 Photography Landing Page.',
    link: 'https://c30d31f8.digitalkreatif.pages.dev/',
    image: `https://api.screenshotmachine.com?key=${API_KEY}&url=https://c30d31f8.digitalkreatif.pages.dev/&dimension=1280x870`,
    code : '#0003'
  },
  {
    title: 'Growing',
    description: 'Bootstrap 4 Venture Capitalist Agency Landing Page.',
    link: 'https://0f69e2d1.digitalkreatif.pages.dev/',
    image: `https://api.screenshotmachine.com?key=${API_KEY}&url=https://0f69e2d1.digitalkreatif.pages.dev/&dimension=1280x870`,
    code : '#0004'
  },
  {
    title: 'Stride',
    description: 'Responsive Bootstrap 5 Landing Page.',
    link: 'https://25ef1f3a.digitalkreatif.pages.dev/',
    image: `https://api.screenshotmachine.com?key=${API_KEY}&url=https://25ef1f3a.digitalkreatif.pages.dev/&dimension=1280x870`,
    code : '#0005'
  },
  {
    title: 'Nomad force',
    description: 'Bootstrap 5 HTML5 Landing Page.',
    link: 'https://51bffcae.digitalkreatif.pages.dev/',
    image: `https://api.screenshotmachine.com?key=${API_KEY}&url=https://51bffcae.digitalkreatif.pages.dev/&dimension=1280x870`,
    code : '#0006'
  },
  {
    title: 'Alien',
    description: 'Bootstrap 4 HTML5 Business Website.',
    link: 'https://a2aca4e0.digitalkreatif.pages.dev/',
    image: `https://api.screenshotmachine.com?key=${API_KEY}&url=https://a2aca4e0.digitalkreatif.pages.dev/&dimension=1280x870`,
    code : '#0007'
  },
  {
    title: 'Oinia',
    description: 'Bootstrap 4 Educational Website.',
    link: 'https://8128d611.digitalkreatif.pages.dev/',
    image: `https://api.screenshotmachine.com?key=${API_KEY}&url=https://8128d611.digitalkreatif.pages.dev/&dimension=1280x870`,
    code : '#0008'
  },
  {
    title: 'BuilderMax',
    description: 'Bootstrap 4 HTML5 Builder Construction Services.',
    link: 'https://cd551b02.digitalkreatif.pages.dev/',
    image: `https://api.screenshotmachine.com?key=${API_KEY}&url=https://cd551b02.digitalkreatif.pages.dev/&dimension=1280x870`,
    code : '#0009'
  },
  {
    title: 'Uoni',
    description: 'Bootstrap 4 HTML5 Corporate Website.',
    link: 'https://a2384a8f.digitalkreatif.pages.dev/',
    image: `https://api.screenshotmachine.com?key=${API_KEY}&url=https://a2384a8f.digitalkreatif.pages.dev/&dimension=1280x870`,
    code : '#0010'
  },
  {
    title: 'Terapia',
    description: 'Bootstrap 5 HTML5 Fitness Website.',
    link: 'https://d0d7d699.digitalkreatif.pages.dev/',
    image: `https://api.screenshotmachine.com?key=${API_KEY}&url=https://d0d7d699.digitalkreatif.pages.dev/&dimension=1280x870`,
    code : '#0011'
  },
  {
    title: 'Travela',
    description: 'HTML5 Tourism Business Website.',
    link: 'https://9a73dcd9.digitalkreatif.pages.dev/',
    image: `https://api.screenshotmachine.com?key=${API_KEY}&url=https://9a73dcd9.digitalkreatif.pages.dev/&dimension=1280x870`,
    code : '#0012'
  }
];
